import { createContext, useContext, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import api from "libs/api";
import { useApp } from "context/app";

const DashboardContext = createContext();

const DashboardProvider = ({ children }) => {
  const { websites, current_website } = useApp();
  const [selected_website, setSelectedWebsite] = useState(
    websites?.[0]?._id || null,
  );
  const [uptime_period, setUptimePeriod] = useState("day");

  const isDashboardEmpty = !(websites?.length > 0);

  const { isLoading: loading, data: dashboard } = useQuery({
    queryKey: ["client_dashboard", current_website?._id],
    queryFn: () => api.get(`/client/dashboard?website=${current_website?._id}`),
    enabled: !isDashboardEmpty,
  });

  const { isLoading: uptime_loading, data: uptime } = useQuery({
    queryKey: ["client_dashboard_uptime", current_website?._id, uptime_period],
    queryFn: () =>
      api.get(
        `/client/dashboard/uptime?website=${current_website?._id}&period=${uptime_period}`,
      ),
    enabled: !isDashboardEmpty,
  });

  const value = useMemo(() => {
    return {
      websites,
      uptime,
      dashboard,
      uptime_period,
      loading,
      uptime_loading,
      selected_website,
      setSelectedWebsite,
      setUptimePeriod,
      isDashboardEmpty,
    };
    // eslint-disable-next-line
  }, [
    dashboard,
    uptime,
    selected_website,
    uptime_period,
    loading,
    uptime_loading,
    isDashboardEmpty,
  ]);

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};

const useDashboard = () => useContext(DashboardContext);
export { DashboardContext, useDashboard };
export default DashboardProvider;
